'use client';

import { Box, Stack } from "@mui/material";
import CookieButton from "@/app/__to_be_integrated/_____components/floating-edge-menu/components/cookies/CookieButton";
import A11yButton from "@/app/__to_be_integrated/_____components/floating-edge-menu/components/a11y/A11yButton";
import { usePathname } from "next/navigation";

export default function FloatingEdgeMenu() {
    const pathname = usePathname();

    if (pathname.startsWith('/admin')) return null;

    return (
        <Box
            className="floating-edge-menu fixed hidden md:block left-8 bottom-8 z-[1000]"
        >
            <Stack spacing={2} >
                <CookieButton />
                <A11yButton />
            </Stack>
        </Box>
    )
}